import {UserDropdown} from '@components/commons/user-dropdown'
import {routes} from '@utilities/constants/routes.tsx'
import icon from '/favicon1.svg'
import {Link} from 'react-router-dom'
import {Container} from '@components/ui/container.tsx'

/** Minimal sticky header for the opt-in page: logo on the left, avatar on the right. */
export const FloorPlanOptInHeader = () => (
    <div className="h-16 border-b border-neutral-200 bg-white sticky top-0 z-mobile-menu">
        <Container className="flex h-full items-center justify-between gap-8">
            <Link to={routes.HOME.handle.fullPath} className="flex cursor-pointer">
                <img src={icon} alt="icon" />
            </Link>
            <UserDropdown />
        </Container>
    </div>
)
